import { Box, Flex, Text } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonLink } from 'components/common/link';
import { CommonStepHeader } from 'components/machine/dialogs/installation/header';
import { MachineContext } from 'contexts/machine.context';
import { CalibrateProc } from 'lib_ts/enums/machine.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useContext, useEffect } from 'react';

const COMPONENT_NAME = 'StepProjectorConfig';
const PROJECTOR_GUIDE =
  'https://docs.google.com/document/d/1Gdbpm3W3FbDQZIlhYY42TjbMV1SIsFlR_i5-Jq2lym0/edit?tab=t.0#heading=h.wqfb52cjpozs';

export const StepProjectorConfig = () => {
  const { calibrate } = useContext(MachineContext);

  // toggle rulers & outline on and off when we start/stop this step
  // Note: it's possible for the below cleanup function to not run if the user closes their browser
  // this would leave the rulers and outline on and require the user to toggle them off in Projector Setup
  useEffect(() => {
    calibrate([CalibrateProc.ProjectorRulers], COMPONENT_NAME);
    calibrate([CalibrateProc.ProjectorOutline], COMPONENT_NAME);

    return () => {
      calibrate([CalibrateProc.ProjectorRulers], COMPONENT_NAME);
      calibrate([CalibrateProc.ProjectorOutline], COMPONENT_NAME);
    };
  }, []);

  return (
    <ErrorBoundary identifier={COMPONENT_NAME}>
      <Flex
        direction="column"
        gap="4"
        style={{
          height: '100%',
        }}
      >
        <CommonStepHeader label="Projector Configuration" />

        <Flex direction="column" gap="4">
          <Text color={RADIX.COLOR.SECONDARY}>
            <ol className="no-margin" style={{ paddingInlineStart: '20px' }}>
              <li>
                Use a measuring tape to compare the projected measurements to
                actual ones.
              </li>
              <li>
                If the projection appears too large or too small, use the
                buttons to adjust the frame until it fits on the panel.
              </li>
              <ul
                className="no-margin"
                style={{ paddingInlineStart: '20px' }}
              ></ul>
            </ol>
          </Text>
          <Text color={RADIX.COLOR.SECONDARY}>
            Adjust until the projection matches the real measurements
            accurately.
          </Text>
          <Text color={RADIX.COLOR.SECONDARY}>
            Additional projector controls can found under{' '}
            <strong>Settings &gt; Projector</strong> and detailed instructions
            on setting up the projector can be found{' '}
            <CommonLink url={PROJECTOR_GUIDE}>here</CommonLink>.
          </Text>
        </Flex>
        <Box m="auto">
          <img
            style={{
              width: '331px',
            }}
            src="/img/renders/projector-setup.png"
          />
        </Box>
      </Flex>
    </ErrorBoundary>
  );
};
